import styled from 'styled-components';
import { AppBar, FormControl, IconButton, Popover, Toolbar, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Logo = styled.img`
  width: 55%;
  cursor: pointer;
  margin: 5px 0 0 0;
  @media only screen and (max-width: 1367px) {
    width: 40%;
  }
  @media only screen and (max-width: 1280px) {
    width: 40%;
  }
  @media only screen and (min-width: 1400px) {
    width: 30%;
  }
  @media only screen and (max-width: 992px) {
    width: 51%;
  }
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
  @media only screen and (max-width: 600px) {
    width: 80%;
    margin-top: 10px;
  }
`;

export const StyledAppBar = styled(AppBar)`
  padding: 9px 0;
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  display: flex;
  justify-content: space-around;
  background: white;
  border-bottom: 2px solid ${({ theme }) => theme.palette.primary.main};
  @media only screen and (max-width: 600px) {
    padding: 0 0 9px;
  }
`;

export const StyledToolbar = styled(Toolbar)`
  padding-right: ${({ theme }) => theme.spacing(4) + 'px'};
  padding-left: ${({ theme }) => theme.spacing(4) + 'px'};
  @media only screen and (max-width: 600px) {
    justify-content: space-between;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 8px 0px 0px;
  display: flex;
  margin-left: auto;
  justify-content: flex-end;
  align-items: center;
`;

export const SearchInput = styled(FormControl)`
  width: 55%;
  @media only screen and (max-width: 992px) {
    width: 75%;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
  @media only screen and (max-width: 600px) {
    width: 80%;
    margin: 0 auto;
  }
  .Mui-focused {
    svg {
      transition: 0.2s;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
  .MuiOutlinedInput-input {
    padding: 10.5px 14px;
  }
  .MuiInputLabel-outlined {
    transform: translate(14px, 11px) scale(1);
  }
  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
  }
  .MuiOutlinedInput-root {
    border-radius: 80px !important;
  }
`;

export const StyledSearchAdornment = styled(FontAwesomeIcon)`
  color: rgba(0, 0, 0, 0.54);
  padding: 12px;
  overflow: visible;
  font-size: 1.5rem;
  margin-right: -10px;
`;

export const StyledIconButton = styled(IconButton)`
  height: 42px;
  min-width: 45px;
  margin-right: 10px;
  color: ${({ theme }) => theme.palette.secondary.main};
  &:last-child {
    margin-left: 10px;
    &:hover {
      transition: 0.3s;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

export const StyledSearch = styled(Autocomplete)`
  width: 300px;
  margin-right: 25px;
  margin-top: 5px;
  .MuiOutlinedInput-root {
    height: 36px;
  }
  .MuiInputLabel-outlined {
    transform: translate(14px, 11px) scale(1);
  }
  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
  }
  input.MuiInputBase-input {
    padding-top: 0 !important;
  }
`;

export const Mobile = styled.div`
  display: none;
  @media only screen and (max-width: 600px) {
    display: flex;
  }
`;

export const Desktop = styled.div`
  display: flex;
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

export const StyledNavLink = styled(NavLink)`
  @media only screen and (max-width: 600px) {
    justify-content: center;
    margin-bottom: 10px;
  }
`;

export const NotificationsTitle = styled(Typography)`
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.primary.main};
`;
export const TitleIntranet = styled(Typography)`
  font-family: IBMPlexSans-SemiBold;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export const NotificationsPopover = styled(Popover)`
  .MuiPopover-paper {
    padding: 10px 20px 15px;
    width: 29%;
  }
  @media only screen and (max-width: 768px) {
    .MuiPopover-paper {
      width: 41%;
    }
  }
  @media only screen and (max-width: 600px) {
    .MuiPopover-paper {
      width: 70%;
    }
  }
`;

export const NotificationArea = styled.div`
  cursor: pointer;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  p {
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: bold;
    @media only screen and (max-width: 600px) {
      font-size: 0.9rem;
    }
  }
  &:hover {
    transition: 0.3s;
    background: rgba(238 238 238 / 40%);
    p {
      transition: 0.3s;
      color: ${({ theme }) => theme.palette.primary.main};
    }
    .initials {
      transition: 0.5s;
      background: ${({ theme }) => theme.palette.primary.main};
      color: white;
    }
  }
`;

export const InitialsIcon = styled.div`
  width: 53px;
  text-align: center;
  background: #eeeeee;
  height: 53px;
  border-radius: 40px;
  margin-right: 20px;
  color: ${({ theme }) => theme.palette.secondary.main};
  display: flex;
  justify-content: center;
  align-items: center;
`;
